import ajax from 'Site/js/util/ajax.fetch';
import Avatar from 'Profile/component/Avatar.vue';
import collapseDirective from 'Site/directive/collapse';
import dropdownDirective from 'Site/directive/dropdown';
import forumMediaMixin from 'Forum/js/mixin/forumMedia';
import ForumPost from 'Forum/component/ForumPost.vue';
import ForumPostForm from 'Forum/component/ForumPostForm.vue';
import Impressions from 'Site/js/util/impressions';
import miniprofileDirective from 'Profile/directive/miniprofile';
import Modal from 'Site/component/Modal.vue';
import PaginationValidation from 'Site/js/mixin/pagination.input.check';
import PromptSignup from 'Site/js/mixin/prompt.signup';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapState } from 'vuex';
import Wysiwyg from 'Site/component/Wysiwyg.vue';

export default {
    forum() {
        new Vue({ /* eslint no-new: 0 */
            el: '#page-body',
            name: 'forum',
            store,
            directives: {
                dropdown: dropdownDirective,
                miniprofile: miniprofileDirective
            }
        });

        new Impressions('.profile-avatar', 'Forum'); // eslint-disable-line no-new
    },
    'forum-view': () => {
        if (document.getElementById('forum-view-body')) {
            new Vue({ // eslint-disable-line no-new
                el: '#forum-view-body',
                name: 'forumListTopics',
                store,
                directives: {
                    dropdown: dropdownDirective,
                    miniprofile: miniprofileDirective
                },
                mixins: [PaginationValidation, PromptSignup]
            });
        }

        new Impressions('.profile-avatar', 'Forum'); // eslint-disable-line no-new
    },
    'forum-search-posts': () => {
        if (document.getElementById('forum-page')) {
            new Vue({ // eslint-disable-line no-new
                el: '#forum-page',
                name: 'forumSearchPosts',
                store,
                components: {
                    ForumPost
                },
                directives: {
                    dropdown: dropdownDirective,
                    miniprofile: miniprofileDirective
                },
                mixins: [PaginationValidation, PromptSignup],
                data() {
                    return {
                        posts: store.state.config.data.posts
                    };
                },
                methods: {
                    confirmDelete(text, url) {
                        this.$store.dispatch('showConfirm', {
                            text,
                            callback() {
                                ajax.delete(url).then((response) => {
                                    this.$store.dispatch('notify', { msg: response.message });
                                    window.location.reload();
                                });
                            }
                        });
                    },
                    removePost(post) {
                        this.posts = this.posts.filter(checkPost => checkPost !== post);
                    },
                    scrollToReply(quotePost) {
                        document.querySelector('#forumPost').scrollIntoView({ block: 'nearest' });
                        this.$refs.replyBox.focus(quotePost);
                    },
                }
            });
        }
    },
    'forum-view-add': () => {
        new Vue({
            el: '#page-body',
            name: 'forumNewTopic',
            store,
            data() {
                return {
                    message: store.state.config.data.message
                };
            },
            components: {
                Wysiwyg
            },
            computed: mapState(['t']),
            directives: {
                collapse: collapseDirective
            },
            mixins: [forumMediaMixin]
        });
    },
    'forum-view-view': () => {
        const vue = new Vue({
            el: '#page-body',
            name: 'forumViewTopic',
            store,
            mixins: [PaginationValidation, PromptSignup],
            components: {
                Avatar,
                ForumPost,
                ForumPostForm,
                Modal
            },
            computed: mapState(['t']),
            directives: {
                dropdown: dropdownDirective,
                miniprofile: miniprofileDirective
            },
            data() {
                return {
                    lastPostId: store.state.config.data.lastPostId,
                    posts: store.state.config.data.posts,
                    showMergeModal: false,
                    showMoveModal: false
                };
            },
            methods: {
                addPost(post) {
                    this.posts.push(post);
                },
                confirmDelete(text, url, redirect) {
                    this.$store.dispatch('showConfirm', {
                        text,
                        callback() {
                            ajax.delete(url).then((response) => {
                                this.$store.dispatch('notify', { msg: response.message });
                                document.location = redirect;
                            });
                        }
                    });
                },
                removePost(post) {
                    this.posts = this.posts.filter(checkPost => checkPost !== post);
                },
                scrollToReply(quotePost) {
                    document.querySelector('.forum-quick-add').scrollIntoView({ block: 'nearest' });
                    this.$refs.replyBox.focus(quotePost);
                },
                submitMerge() {
                    document.querySelector('#mergeThread').submit();
                },
                submitMove() {
                    document.querySelector('#moveThread').submit();
                }
            },
            mounted() {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        if (window.location.hash !== '') {
                            let selector = window.location.hash;
                            if (window.location.hash === '#lastPost') {
                                selector = `#post${this.lastPostId}`;
                            }
                            const $post = document.querySelector(selector);
                            if ($post) {
                                setTimeout(() => {
                                    $post.scrollIntoView({ block: 'nearest' });
                                    $post.classList.add('site-bg');
                                    setTimeout(() => {
                                        $post.classList.remove('site-bg');
                                    }, 500);
                                }, 150);
                            }
                        }
                    });
                });
            }
        });

        if (document.querySelector('#threadMoveBtn') && document.querySelector('#threadMergeBtn')) {
            document.querySelector('#threadMoveBtn').addEventListener('click', (e) => {
                e.preventDefault();
                vue.showMoveModal = true;
            });

            document.querySelector('#threadMergeBtn').addEventListener('click', (e) => {
                e.preventDefault();
                vue.showMergeModal = true;
            });
        }

        new Impressions('.profile-avatar', 'Forum'); // eslint-disable-line no-new
    }
};
